var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "icon-details-styling",
      attrs: { id: "icon-family-style", action: "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
        },
      },
    },
    [
      !_vm.isNotShowingFamilyAndStyles
        ? _c(
            "div",
            {
              staticClass: "margin-bottom-xl",
              staticStyle: {
                display: "grid",
                "grid-template-columns": "1fr 1fr",
                gap: "var(--spacing-md)",
              },
            },
            [
              _vm.version !== 5
                ? _c(
                    "div",
                    {},
                    [
                      _c("wa-select-custom", {
                        attrs: {
                          value: _vm.selectedPack,
                          options: _vm.iconPacks,
                          "custom-style": _vm.selectCustomStyle,
                          "custom-select-style": _vm.selectCustomSelectStyle,
                          "option-label-prop": "label",
                          "icon-name": "faSwatchbook",
                          "is-minimal": "",
                          label: "Icon Family",
                        },
                        on: { change: (value) => _vm.updatePack(value) },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {}, [
                _c(
                  "span",
                  { staticClass: "sr-only", attrs: { id: "icon_style_label" } },
                  [_vm._v("Select an Icon Style")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "buttons select-icon-style",
                    staticStyle: {
                      display: "grid",
                      "grid-template-columns": "1fr 1fr 1fr 1fr",
                    },
                    attrs: {
                      id: "icon_style",
                      "aria-labelledby": "icon_style_label",
                    },
                  },
                  _vm._l(_vm.iconStyles, function (style) {
                    return _c(
                      "button",
                      {
                        key: `${style.family}-${style.style}`,
                        class: [
                          "select-icon-style-button margin-top-0 compact",
                          {
                            active:
                              _vm.styling.style === "duotone"
                                ? style.family === _vm.styling.style &&
                                  style.style === "solid"
                                : style.style === _vm.styling.style &&
                                  style.family === _vm.styling.family,
                          },
                        ],
                        style: _vm.styleSelectButtonStyle(
                          style.family,
                          style.style
                        ),
                        attrs: {
                          "aria-label": _vm.getLabel(style),
                          "data-balloon-pos": "up",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.updateFamilyStyle(
                              style.style,
                              style.family
                            )
                          },
                        },
                      },
                      [
                        _c("i", {
                          class: _vm.iconClass(style.family, style.style),
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }